import PropTypes from 'prop-types';
import { useFormContext, Controller } from 'react-hook-form';
import { FormControlLabel, Switch, Box, Typography } from '@mui/material';

RHFSwitch.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  helperText: PropTypes.string,
  disabled: PropTypes.bool,
  color: PropTypes.string,
};

export default function RHFSwitch({ 
  name, 
  label, 
  helperText, 
  disabled = false, 
  color = 'primary',
  ...other 
}) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
          <FormControlLabel
            control={
              <Switch
                {...field}
                checked={!!field.value}
                disabled={disabled}
                color={color}
                onChange={(e) => field.onChange(e.target.checked)}
                {...other}
              />
            }
            label={
              <Typography variant="body2" fontWeight={500}>
                {label}
              </Typography>
            }
            sx={{
              margin: 0,
              display: 'flex',
              alignItems: 'center',
              gap: 1,
            }}
          />
          {helperText && (
            <Typography variant="caption" color="text.secondary" sx={{ ml: 0.5 }}>
              {helperText}
            </Typography>
          )}
          {error && (
            <Typography variant="caption" color="error" sx={{ ml: 0.5 }}>
              {error.message}
            </Typography>
          )}
        </Box>
      )}
    />
  );
}